// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"934":"c4f42ce1","997":"d4a84bc5"}[chunkId] + ".chunk.js");